import { LoginActions, LoginRequest, UserAuth } from "../domain/login";
import { loginService } from "../infrastructure/services/loginService";
import { userAuthStore } from "../infrastructure/store/userAuthStore";
import { getRouteFromLogin } from "@/business/auth/application/getRouteFromLogin";

export const login = {
  async execute(username: string, password: string): Promise<string> {
    const request: LoginRequest = await LoginActions().createLoginRequest(
      username,
      password
    );
    const user: UserAuth = await loginService.execute(request);
    await userAuthStore().updateUserAuthSession(user);
    return getRouteFromLogin.execute(user.role);
  },
};
